import { onUnmounted, ref } from 'vue';
import { debounce } from 'lodash-es';

export function useFormTooltips() {
  const tooltipsDisabled = ref(false);
  const enableTooltip = debounce(() => (tooltipsDisabled.value = false), 1000);

  function onInput() {
    tooltipsDisabled.value = true;
    enableTooltip();
  }

  function onFocus() {
    tooltipsDisabled.value = true;
    enableTooltip.cancel();
  }

  function onBlur() {
    enableTooltip.cancel();
    tooltipsDisabled.value = false;
  }

  onUnmounted(() => enableTooltip.cancel());

  return { tooltipsDisabled, onInput, onFocus, onBlur };
}
